/*
 * ALORI cart helper — one version-agnostic bridge between ALORI custom code
 * and the Shapes theme cart.
 *
 * Why this exists: every custom add-to-cart (PDP buy boxes, sticky ATC,
 * subscribe upsell) used to hand-roll its own fetch + section list. When
 * Shapes changed how the cart drawer renders (4.x static sections -> 5.x
 * cart-drawer section), each of those broke separately (e.g. $0.00 subtotal).
 *
 * Now all custom code calls window.AloriCart, and only this file needs to
 * know how the theme renders the cart:
 *   - Shapes 5+: uses the theme's own getCartSectionRequestIds() (utils.js)
 *   - Shapes 4.x: falls back to the static section list
 *
 * API
 *   AloriCart.add(items, { sourceId, openDrawer })  -> Promise<cartAddResponse>
 *   AloriCart.refresh()                              -> Promise (re-renders drawer, count, footer)
 *   AloriCart.sectionIds()                           -> string[]
 *   AloriCart.openDrawer()
 */
(function () {
  'use strict';

  var STATIC_SECTION_IDS = ['cart-items', 'cart-footer', 'cart-item-count', 'cart-live-region'];

  function sectionIds() {
    try {
      if (typeof window.getCartSectionRequestIds === 'function') {
        var ids = window.getCartSectionRequestIds();
        if (ids && ids.length) return ids;
      }
    } catch (e) {}
    return STATIC_SECTION_IDS.slice();
  }

  function addUrl() {
    var base = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    return base.replace(/\.js$/, '') + '.js';
  }

  function fetchSections() {
    // No "Accept: application/json" header here: on product pages Shopify would
    // answer with the product JSON instead of the Section Rendering response.
    var url = window.location.pathname + '?sections=' + sectionIds().map(encodeURIComponent).join(',');
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function dispatch(name, detail) {
    document.body.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  }

  function openDrawer() {
    try {
      if (window.Alpine && window.Alpine.store('modals')) {
        window.Alpine.store('modals').open('cart');
      }
    } catch (e) {}
  }

  function add(items, opts) {
    opts = opts || {};
    var ids = sectionIds();
    return fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ids.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            var err = new Error(data.description || data.message || 'cart-add-failed-' + r.status);
            err.response = data;
            throw err;
          }
          return data;
        });
      })
      .then(function (data) {
        // Older endpoints/themes may not return sections — fetch them if missing.
        if (data.sections && Object.keys(data.sections).length) return data;
        return fetchSections().then(function (sections) {
          data.sections = sections;
          return data;
        });
      })
      .then(function (data) {
        dispatch('shapes:cart:afteradditem', { response: data, sourceId: opts.sourceId || 'alori-custom-atc' });
        if (opts.openDrawer !== false) openDrawer();
        return data;
      });
  }

  function refresh() {
    return fetchSections().then(function (sections) {
      dispatch('shapes:cart:update', { response: { sections: sections } });
      return sections;
    });
  }

  window.AloriCart = {
    add: add,
    refresh: refresh,
    sectionIds: sectionIds,
    openDrawer: openDrawer
  };
})();
